import React, { useEffect } from 'react';
import get from 'lodash/get';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';

import Header from '../../layout/Header.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

import { env } from '~/commons/config';

const PageSchDashBoard = () => {
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: 'api/core/users/self',
    });
  }, []);

  return (
    <PageHttp res={res}>
      {(user) => {
        const userInfo = [
          { label: '名字', v: get(user, 'name.full.zhhk') },
          { label: 'Name', v: get(user, 'name.full.en') },
          { label: 'Username', v: get(user, 'username') },
        ].filter((({ v }) => v));

        const schInfo = [
          { label: '學校', v: get(user, 'school.title.zhhk') },
          { label: 'School', v: get(user, 'school.title.en') },
          {
            label: 'District',
            v: get(env, `districts.${user.school.district}.zhhk`),
          },
          {
            label: 'Stage',
            v: {
              p: '小學',
              s: '中學',
            }[user.school.stage],
          },
        ].filter((({ v }) => v));

        return (
          <>
            <Header>
              {user.school.title.en || user.school.title.zhhk}
            </Header>
            <div className="card p-4">
              <div className="row align-items-center">
                <div className="col">
                  {userInfo.map((a, i) => (
                    <div className="row" key={i}>
                      <div className="col-4">
                        <strong>{a.label}</strong>
                      </div>
                      <div className="col">
                        {a.v}
                      </div>
                    </div>
                  ))}
                  <hr/>
                  {schInfo.map((a, i) => (
                    <div className="row" key={i}>
                      <div className="col-4">
                        <strong>{a.label}</strong>
                      </div>
                      <div className="col">
                        {a.v}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-auto">
                  <Link
                    to={'/admin/users/admins/self'}
                    className="btn btn-link"
                  >
                    <FA icon={faPencilAlt} size="lg" />
                  </Link>
                </div>
              </div>
            </div>
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageSchDashBoard;
